"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HevyCoachDefaultPlan = void 0;
exports.HevyCoachDefaultPlan = {
    maximum_clients: 0,
    id: 'hevy_coach_free',
    title: 'Free',
    renewal_period: 'lifetime',
    type: 'none',
};
